// 全角文字を半角文字へ変換する

export const fullTextToHalfText = (fullText: string): string => {
  return fullText.replace(/[Ａ-Ｚａ-ｚ０-９]/g, (s) => {
    return String.fromCharCode(s.charCodeAt(0) - 0xfee0);
  });
};
